/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryFlat } from '../../models/category-flat';

export interface ApiProductsqueryCategoriesHighlightedGet$Params {
}

export function apiProductsqueryCategoriesHighlightedGet(http: HttpClient, rootUrl: string, params?: ApiProductsqueryCategoriesHighlightedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryFlat>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryCategoriesHighlightedGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CategoryFlat>>;
    })
  );
}

apiProductsqueryCategoriesHighlightedGet.PATH = '/api/productsquery/categories/highlighted';
